(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(39346);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10367);
;// CONCATENATED MODULE: ./src/views/Home/style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-size: 100% 100%;\n  padding: 20px 40px;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-around;\n  align-items: center;\n  color: #fff;\n  .right {\n    width: 49%;\n    img {\n      width: 100%;\n      aspect-ratio: 682/626;\n    }\n  }\n  .left {\n    width: 49%;\n    padding: 90px 0;\n    div:nth-child(1) {\n      width: 100%;\n      img {\n        width: 100%;\n        height: auto;\n      }\n    }\n    .Mechanism {\n      font-size: 30px;\n      line-height: 61px;\n      margin-top: 86px;\n    }\n    .btn div:hover {\n      cursor: pointer;\n    }\n    .btn {\n      display: flex;\n      margin-top: 124px;\n      font-size: 30px;\n      font-size: 30px;\n      text-align: center;\n      .create,\n      .learn {\n        width: 307px;\n        line-height: 88px;\n        background: #fb512d;\n        border-radius: 15px;\n        color: #000000;\n      }\n      .learn {\n        margin-left: 34px;\n        background: #d9ebeb;\n      }\n    }\n  }\n  @media (max-width: 968px) {\n    display: block;\n    .right {\n      width: 100%;\n      height: auto;\n    }\n    .left {\n      padding: 50px 0;\n      width: 100%;\n      .Mechanism {\n        width: 100%;\n        text-align: center;\n        font-size: 15px;\n        margin-top: 20px;\n        line-height: 30px;\n      }\n      .btn {\n        margin-top: 20px;\n      }\n      .btn .create,\n      .btn .learn {\n        width: 153px;\n        line-height: 44px;\n        border-radius: 8px;\n        font-size: 15px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  background: #262626;\n  padding: 40px;\n  text-align: center;\n  > div:hover {\n    transform: scale(1.1);\n    cursor: pointer;\n  }\n  > div {\n    width: 30%;\n    aspect-ratio: 660/330;\n    position: relative;\n    transition: transform 0.3s ease;\n    img {\n      width: 100%;\n      height: 100%;\n    }\n    span {\n      padding: 0 10px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      font-family: Microsoft YaHei;\n      font-weight: 400;\n      font-size: 22px;\n      color: #cccccc;\n      line-height: 76px;\n      width: 100%;\n      background: rgba(0, 0, 0, 0.5);\n      position: absolute;\n      z-index: 10;\n      bottom: 0;\n      left: 0;\n    }\n  }\n  @media (max-width: 968px) {\n    box-sizing: border-box;\n    display: block;\n    padding: 50px 45px;\n    > div {\n      width: 100%;\n      margin-bottom: 20px;\n      span {\n        font-size: 14px;\n        line-height: 38px;\n        height: 40px;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 968px) {\n    .advantage1 {\n      .title {\n        font-size: 35px !important;\n        div{\n          width:42px !important;\n          height:28px !important;\n        }\n      }\n    }\n    .content {\n      padding: 12px;\n      .title11 {\n        position: relative;\n        font-size: 35px !important;\n        padding: 50px 0 !important;\n        padding: 0;\n        ul {\n          margin: 0;\n          width: 42px;\n          height: 28px;\n          margin: 0 0 0 10px;\n        }\n      }\n      .describe {\n        font-size: 14px !important;\n        line-height: 30px !important;\n        width: 70% !important;\n      }\n\n      .function {\n        > div:nth-child(1) {\n          width: 100%;\n        }\n        margin: 100px auto 0;\n        padding: 0 30px 100px 30px;\n        display: block !important;\n        .token {\n          width: 100%;\n          margin-left: 0;\n          text-align: center;\n          .create {\n            font-size: 23px;\n            margin-top: 50px;\n          }\n          p {\n            font-size: 13px;\n            line-height: 23px;\n            margin: 20px auto;\n            width: 80%;\n          }\n          ul {\n            width: 100%;\n            display: flex;\n            margin-top: 30px;\n            flex-wrap: wrap;\n          }\n          ul li {\n            background-size: 18px 18px;\n            font-size: 16px;\n            line-height: 36px;\n            padding-left: 30px;\n            margin-left: 10px;\n          }\n          .line {\n            width: 62px;\n            height: 62px;\n            bottom: -84px;\n            left: calc(50% - 31px);\n            img {\n              width: 20px;\n              height: 6px;\n              margin: 0;\n            }\n          }\n        }\n      }\n    }\n    .main {\n      padding-top: 30px;\n      .function {\n        display: block;\n        padding: 0 30px 100px 30px;\n        margin: 50px auto 0;\n        > div:nth-child(1) {\n          width: 100%;\n        }\n        .token {\n          margin-left: 0;\n          text-align: center;\n          // background:red;\n          position: relative;\n        }\n        .create {\n          font-size: 23px !important;\n          margin-top: 80px !important;\n        }\n        p {\n          font-size: 13px;\n          line-height: 23px;\n          margin: 20px auto;\n          width: 100%;\n        }\n        ul {\n          display: flex;\n          margin-top: 30px;\n          flex-wrap: wrap;\n        }\n        ul li {\n          background-size: 18px 18px;\n          font-size: 16px;\n          line-height: 36px;\n          padding-left: 30px;\n          margin-left: 10px;\n        }\n        .line {\n          width: 62px !important;\n          height: 62px !important;\n          bottom: -84px !important;\n          left: calc(50% - 31px) !important;\n          img {\n            width: 20px;\n            height: 6px;\n            margin: 0;\n          }\n        }\n      }\n      .third,\n      .first,\n      .second {\n        .token {\n          width: 100% !important;\n        }\n      }\n      .third,\n      .first {\n        border: 1px solid #4a4a4a !important;\n      }\n    }\n    .advantage {\n      padding-bottom: 30px !important;\n      > .title {\n        font-size: 35px !important;\n        padding-top: 70px !important;\n        img {\n          margin: 0 0 20px 0;\n          width: 42px !important;\n          height: 28px !important;\n        }\n      }\n      > ul {\n        margin-top: 70px !important;\n        padding: 0 30px;\n        display: block !important;\n        li {\n          border-radius: 17px !important;\n          margin: 70px 0;\n          width: 100% !important;\n          // >div:nth-child(1) {\n          \n          //   img{\n          //     width:100%;\n          //     height:100%;\n          //   }\n          // }\n          .de {\n            font-size: 13px !important;\n            width: 80% !important;\n            margin: 0px auto 100px !important;\n          }\n          .price {\n            font-size: 25px !important;\n            margin: 30px !important;\n            margin-top: 91px !important;\n          }\n        }\n      }\n    }\n  }\n\n  // pc端\n  .title11 {\n    font-family: MF YueHei (Noncommercial);\n    font-size: 70px;\n    color: #ffffff;\n    margin: 0 auto;\n    padding: 183px 0 64px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    > ul {\n      width: 84px;\n      height: 56px;\n      margin: 0 0 0 29px;\n      img {\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n  .Img{\n    width:166px;\n    height:158px;\n    display:inline-block;\n    margin-top:-65px;\n    img{\n      width:100%;\n      height:auto;\n    }\n  }\n  .describe {\n    width: 36%;\n    font-size: 28px;\n    color: #ffffff;\n    margin: 0 auto;\n    line-height: 57px;\n    text-align: center;\n  }\n  .main {\n  overflow:hidden;\n    background-image: url(../../../newimages/673.webp);\n    background-size: 100% 100%;\n    .first,\n    .third {\n      flex-direction: row-reverse;\n      border: none;\n    }\n    .first {\n      > div {\n        width: 774px;\n      }\n    }\n    .first,\n    .second,\n    .third {\n      > .token {\n        width: 50%;\n      }\n    }\n  }\n  .content {\n    background-size: 100% 100%;\n    overflow:hidden;\n  }\n  \n  .pm1 {\n    margin-right: 30px;\n  }\n  @media (max-width: 968px) {\n    .pm1 {\n      margin-right: 0px;\n    }\n    .Img{\n      margin-top:-30px !important;\n      width:75px;\n      height:67px;\n    }\n  }\n\n  .advantage1 {\n    padding-bottom: 147px;\n    /* background-image: url(../../../newimages/674.webp); */\n    background-size: 100% 100%;\n    .title {\n      font-size: 70px;\n      color: #fff;\n      padding-top: 100px;\n      display:flex;\n      width:100%;\n      justify-content:center;\n      div{\n        width:84px;\n        height:56px;\n        margin:0 0 20px 20px;\n        img{\n        width:100%;\n        height:100%;\n        }\n      }\n    }\n  }\n  .advantage {\n    padding-bottom: 147px;\n    background-image: url(../../../newimages/674.webp);\n    background-size: 100% 100%;\n    .title {\n      font-size: 70px;\n      color: #fff;\n      padding-top: 100px;\n      display:flex;\n      justify-content:center;\n    }\n    ul {\n      display: flex;\n      justify-content: space-around;\n      margin-top: 140px;\n    }\n    ul li {\n      list-style: none;\n      width: 28%;\n      border-radius: 35px;\n      text-align: center;\n      border: 1px solid #4a4a4a;\n      color: #fff;\n      position: relative;\n      // div:nth-child(1) {\n      //   position: absolute;\n      //   top: -55px;\n      //   right: 0;\n      //   // width: 100%;\n      //   /* height: 406px; */\n      }\n      .price {\n        font-size: 47px;\n        color: #ffffff;\n        margin: 183px 0 66px;\n      }\n      .de {\n        width: 60%;\n        font-size: 20px;\n        line-height: 41px;\n        margin: 0 auto 167px;\n      }\n    }\n  }\n  .function {\n    width: 86%;\n    padding: 40px;\n    border-radius: 35px;\n    border: 1px solid #666666;\n    margin: 100px auto;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    color: #ffffff;\n    > div:nth-child(1) {\n      width: 45%;\n      aspect-ratio:774/862;\n    }\n    .token {\n      width: 45%;\n\n      position: relative;\n      ul li a:hover {\n        color: #fc633c;\n      }\n      .line:hover {\n        background: #fc633c;\n        cursor: pointer;\n      }\n      .line {\n        width: 137px;\n        height: 137px;\n        border-radius: 50%;\n        border: 1px solid #4d4d4d;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        right: 20px;\n        bottom: 20px;\n      }\n      .create {\n        font-size: 46px;\n        margin-top: 81px;\n      }\n    }\n    p {\n      font-size: 26px;\n      margin-top: 46px;\n      width: 65%;\n      line-height: 46px;\n      color: #999999;\n    }\n    ul {\n      margin-top: 70px;\n      width: 70%;\n    }\n    ul li:hover {\n      background-image: url(/newimages/list1.png);\n      color: #fc633c;\n    }\n    ul li {\n      list-style: none;\n      font-size: 32px;\n      line-height: 73px;\n      background-image: url(/newimages/list.png);\n      background-repeat: no-repeat;\n      background-position: left center;\n      padding-left: 60px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #1c1c1c;\n  font-size: 20px;\n  color: #cccccc;\n  line-height: 60px;\n  display: flex;\n  justify-content: space-between;\n  padding: 112px 118px;\n  img {\n    width: 274px;\n    height: 102px;\n  }\n  div {\n    display: flex;\n    justify-content: space-around;\n    width: 80%;\n  }\n  ul > li {\n    list-style: none;\n  }\n  @media (max-width: 968px) {\n    div {\n      width: 100%;\n      margin-left: 10px;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      ul {\n        width: 33%;\n        margin-top: 10px;\n      }\n    }\n    img {\n      width: 136px;\n      height: 50px;\n    }\n    padding: 25px;\n    font-size: 13px;\n    line-height: 30px;\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var Platform = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf64e5f9-0"
})(_templateObject());
var OfficialWebsite = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf64e5f9-1"
})(_templateObject1());
var Function = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf64e5f9-2"
})(_templateObject2());
var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cf64e5f9-3"
})(_templateObject3());

// EXTERNAL MODULE: ./node_modules/swiper/swiper-react.mjs + 3 modules
var swiper_react = __webpack_require__(2261);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.css
var swiper = __webpack_require__(25194);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-coverflow.css
var effect_coverflow = __webpack_require__(17963);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination.css
var pagination = __webpack_require__(18700);
// EXTERNAL MODULE: ./node_modules/swiper/modules/index.mjs + 26 modules
var modules = __webpack_require__(72074);
;// CONCATENATED MODULE: ./src/views/Home/components/AnimatedElements/style.tsx

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  #app {\n    height: 100%;\n  }\n  html,\n  body {\n    position: relative;\n    height: 100%;\n  }\n\n  body {\n    background: #eee;\n    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\n    font-size: 14px;\n    color: #000;\n    margin: 0;\n    padding: 0;\n  }\n\n  .swiper {\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n\n  .swiper-slide {\n    background-position: center;\n    background-size: cover;\n    width: 600px;\n    border: 1px solid #888;\n  }\n\n  .swiper-slide img {\n    display: block;\n    width: 100%;\n  }\n  .p11 {\n    a {\n      width: 25%;\n      border-radius: 6px;\n      margin: 0 10px;\n      img {\n        width: 100%;\n        aspect-ratio: 706/272;\n      }\n    }\n  }\n  @media (max-width: 968px) {\n    .swiper-slide {\n      width: 250px;\n    }\n  }\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_Platform = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8f0def49-0"
})(style_templateObject());

;// CONCATENATED MODULE: ./src/views/Home/components/AnimatedElements/index.tsx


// Import Swiper React components

// Import Swiper styles



// import required modules


var LazyLoad = (__webpack_require__(1216)/* ["default"] */ .ZP);
function App() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Platform, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                effect: "coverflow",
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "auto",
                initialSlide: 1,
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
                pagination: true,
                modules: [
                    modules/* EffectCoverflow */.lI,
                    modules/* Autoplay */.pt
                ],
                className: "mySwiper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "p11",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://www.okx.com/zh-hans/web3/discover",
                                rel: "nofollow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/oyi.webp",
                                        alt: "欧易 OKX 交易所",
                                        loading: "lazy"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://web3.bitget.com/en/dapp/searchresults",
                                rel: "nofollow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/newimages/p1.webp",
                                        alt: "p1",
                                        loading: "lazy",
                                        className: "pm1"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://dappbay.bnbchain.org/detail/g-token-tool",
                                rel: "nofollow",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/newimages/p2.webp",
                                        alt: "p2",
                                        loading: "lazy"
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/views/Home/index.tsx







var Home_LazyLoad = (__webpack_require__(1216)/* ["default"] */ .ZP);
var Home = function() {
    var t = (0,src/* useTranslation */.$G)() // 多语言插件
    .t;
    var contentStyle = {
        height: "160px",
        color: "#fff",
        lineHeight: "160px",
        textAlign: "center",
        background: "#364d79"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        style: {
                            display: "none"
                        },
                        children: "首页"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Platform, {
                        style: {
                            backgroundImage: lib/* isMobile */.tq ? "url(../../../newimages/641.webp)" : "url(../../../newimages/671.webp)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/newimages/banner.webp",
                                    alt: "banner"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/newimages/platform.webp",
                                            alt: "platform",
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "Mechanism",
                                        children: t("A decentralized pre-sale platform with Link new mechanism, including token creation, rune creation, IDO creation, mining, token pre-sale UltrLink comprehensive functions such as liquidity creation")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "btn",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://sol.gtokentool.com/",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "create",
                                                    children: t("SOL Token Create")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://t.me/+WYb5xrv-IgQyYWE1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "learn",
                                                    children: t("Contact")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OfficialWebsite, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function() {
                                            window.location.href = "https://mining.gtokentool.com/";
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/newimages/website.webp",
                                                alt: "website",
                                                loading: "lazy"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            window.location.href = "https://mining.gtokentool.com/";
                                        },
                                        children: t("One click generation of mining official website")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function() {
                                            window.location.href = "https://ido.gtokentool.com/";
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/newimages/presales.webp",
                                                alt: "presales",
                                                loading: "lazy"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            window.location.href = "https://ido.gtokentool.com/";
                                        },
                                        children: t("One click generation of IDO official website")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        onClick: function() {
                                            window.location.href = "https://nft.gtokentool.com/";
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/newimages/nft.webp",
                                                alt: "nft",
                                                loading: "lazy"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        onClick: function() {
                                            window.location.href = "https://nft.gtokentool.com/";
                                        },
                                        children: t("One click generation of NFT official website")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Function, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content",
                                style: {
                                    backgroundImage: lib/* isMobile */.tq ? "url(../../../newimages/644.webp)" : "url(../../../newimages/672.webp)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "title11",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: t("major function ")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/newimages/function.png",
                                                        alt: "function",
                                                        loading: "lazy"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "describe",
                                        children: t("From creating tokens, managing tokens, to pre-sales, market value management, and trading, it covers the entire process of token sales.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "function",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/newimages/token.webp",
                                                        alt: "token",
                                                        loading: "lazy"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "token",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "create",
                                                        children: t("Token-Factory")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: t("Supports bsc, ton, sol, eth, core, base, arbitrum, heco, pego and other blockchains")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://ton.gtokentool.com/",
                                                                    children: t("ton Token-Factory")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://sol.gtokentool.com/",
                                                                    children: t("sol Token-Factory")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://token.gtokentool.com",
                                                                    children: t("Multi-chain one-click currency issuance")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://token.gtokentool.com",
                                                                    children: t("Publish ERC-314 with one click")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/tokenfactory",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "line",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/newimages/line.png",
                                                                    alt: "line",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "main",
                                style: {
                                    backgroundImage: lib/* isMobile */.tq ? "url(../../../newimages/645.webp)" : "url(../../../newimages/673.webp)"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " first function",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/newimages/presale.webp",
                                                        alt: "pre-sale",
                                                        loading: "lazy"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "token",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "create",
                                                        children: t("Token pre-sale")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: t("Various pre-sale forms, one-click generation of official website, quality upgrade")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/createInscription",
                                                                    children: "IDO"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/fairlaunch",
                                                                    children: t("Pre-sale and super-raised pre-sale")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/createInscription",
                                                                    children: t("Runes")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/mining",
                                                                    children: t("Staking mining")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/fairlaunch",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "line",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/newimages/line.png",
                                                                    alt: "line",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "function second",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/newimages/swaps.webp",
                                                        alt: "swaps",
                                                        loading: "lazy"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "token",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "create",
                                                        children: t("Lock and Trade")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: t("Lock the tokens, lock the liquidity, and stabilize the market")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/createlock",
                                                                    children: t("Token Lock")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/createlock",
                                                                    children: t("LP Lock")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/lplock",
                                                                    children: t("Add liquidity")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/swap",
                                                                    children: t("Swap")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/swap",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "line",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/newimages/line.png",
                                                                    alt: "line",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: " function third",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/newimages/robot.webp",
                                                        alt: "robot",
                                                        loading: "lazy"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "token",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "create",
                                                        children: t("Market Value")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: t("Come out with beautiful K-line and depth")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://sol.gtokentool.com/#/market",
                                                                    children: t("sol market value management")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://ton.gtokentool.com/marketValue",
                                                                    children: t("ton market value management")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://robotv2.gtokentool.com/#/marketbot",
                                                                    children: t("More chain market value management")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://sol.gtokentool.com/#/batchTool/batchCreateWallet",
                                                                    children: t("Batch generation of wallets")
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://sol.gtokentool.com/#/batchTool/batchTransfer/SOL",
                                                                    children: t("Batch transfer")
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/bot",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "line",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: "/newimages/line.png",
                                                                    alt: "line",
                                                                    loading: "lazy"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "advantage",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "title",
                                        children: [
                                            t("Our strengths"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/newimages/function.png",
                                                    alt: "function",
                                                    loading: "lazy"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                style: {
                                                    background: "url('/images/price.webp')",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: "center top",
                                                    backgroundSize: "100% 50%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Img",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/images/priceLogo.webp",
                                                                alt: "priceLogo",
                                                                loading: "lazy"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "price",
                                                        children: t("Super multifunctional")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "de",
                                                        children: t("A complete set of functions for token sales: creating tokens, managing tokens, token pre-sales, market value management, token transactions, etc., supporting multiple chains")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                style: {
                                                    background: "url('/images/func.webp')",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: "center top",
                                                    backgroundSize: "100% 50%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Img",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/images/funcLogo.webp",
                                                                alt: "funcLogo",
                                                                loading: "lazy"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "price",
                                                        children: t("Professional team")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "de",
                                                        children: t("2 years of professional team to create a more solid and reliable blockchain platform to ensure the security of user transactions")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                style: {
                                                    background: "url('/images/profession.webp')",
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: "center top",
                                                    backgroundSize: "100% 50%"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "Img",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: "/images/professionLogo.webp",
                                                                alt: "professionLogo",
                                                                loading: "lazy"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "price",
                                                        children: t("appropriate price")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "de",
                                                        children: t("Continuously optimize products, so that while the quality is upgraded, the price is also reduced to the most favorable, becoming the most cost-effective platform on the entire network")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "advantage1",
                                        style: {
                                            padding: 0,
                                            marginTop: lib/* isMobile */.tq ? 100 : 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "title",
                                            children: [
                                                t("Partner"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: "/newimages/function.png",
                                                            alt: "function",
                                                            loading: "lazy"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(App, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LazyLoad, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/newimages/logo1.png",
                                    alt: "logo1",
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/tokenfactory",
                                                    children: t("Create Token")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/createnft",
                                                    children: t("Create NFT")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/managetokens",
                                                    children: t("Manage Tokens")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/sendertoken",
                                                    children: t("Batch coin issuance")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/increaseAddr",
                                                    children: t("Start fission")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/idov2",
                                                    children: t("Create IDO")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/idov2/list",
                                                    children: t("IDO Management")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/createInscription",
                                                    children: t("Create runes")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/createInscription/list",
                                                    children: t("Rune management")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/inscription",
                                                    children: t("Batch Inscription")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/launchpad",
                                                    children: t("Pre-sale list")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/launchpad/create",
                                                    children: t("Create Link normal pre-sale")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/fairlaunch/create",
                                                    children: t("Create Fairlaunch")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/swap",
                                                    children: t("Swap")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/liquidity",
                                                    children: t("Liquidity")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/lplock",
                                                    children: t("Locked in liquidity")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/lplock",
                                                    children: t("Unlocking liquidity")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/bot",
                                                    children: t("Market Bot")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://robotv2.gtokentool.com",
                                                    children: t("Bot")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://docs.gtokentool.com/",
                                                    children: t("Docs")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx




// import Token from 'views/Token'
var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2261,476,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);